export default __webpack_public_path__ + "b1b571c5b64da3715ed95a29d56a30ac.png";